<template>
  <div id="vrSiteCheckInfo">
    <!-- <p style="color:white">Site Check Info (stid={{ $route.query.stid }})</p> -->
    <ag-grid-vue
      class="ag-theme-balham grid"
      :domLayout="domLayout"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    AgGridVue,
  },
  computed: {
    ...mapGetters(["getAlertOptions"]),
  },
  data() {
    return {
      gridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      domLayout: "autoHeight",
    };
  },
  created() {
    this.getData();
  },
  beforeMount() {
    this.gridOptions.columnDefs = [
      { headerName: "점검일", field: "checkdate", width: 100 },
      { headerName: "담당자", field: "username", width: 100 },
      { headerName: "담당자ID", field: "mnguserid", hide: true },
      { headerName: "점검내역", field: "compcheckdetail" },
    ];
  },
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    getData() {
      if (this.$route.query.stid) {
        var reqBody = {
          stId: this.$route.query.stid,
        };
        this.$http
          .post("/vrPopup/getSiteCheckInfo", reqBody)
          .then((res) => {
            if (res.data.resultyn === "Y") {
              this.gridOptions.api.setRowData(res.data.data);
            } else {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },
};
</script>

<style lang="scss">
#vrSiteCheckInfo {
  width: 100%;
  height: 100%;

  & div.ag-theme-balham.grid {
    background-color: #ffffff00 !important;
    & .ag-root .ag-body .ag-body-viewport {
      overflow-x: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vrpopup/VRSiteCheckInfo.vue